import { Skeleton, Box, Typography, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { getLitterById } from "../services";
import { Link, useParams, useLocation } from "react-router";
import { PuppieCard } from "../components/PuppieCard/PuppieCard";

export const SingleLitter = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const litterName = (location.state as any)?.name || "";
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState<any>({});

  useEffect(() => {
    if (!id) return;
    getLitterById(id).then(async (response) => {
      const litter = response.data;
      setDetails(litter);
      setLoading(false);
    });
  }, [id]);
  return (
    <Box className="article-main">
      <Typography
        variant="h4"
        sx={{
          fontFamily: '"Cinzel", serif',
          color: "#4a3728",
          borderBottom: "2px solid #d4b483",
          pb: 1,
          mb: 2,
        }}
      >
        {loading && !litterName ? <Skeleton variant="text" /> : litterName}
      </Typography>
      <Grid container spacing={3}>
        {loading ? (
          <Skeleton variant="rectangular" height={200} />
        ) : (
          details
            .filter((puppie: any) => puppie?.status !== "adopted")
            .map((puppie: any) => (
              <Grid size={12} key={puppie.id}>
                <Link
                  to={`/puppy/${puppie.id}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <PuppieCard {...puppie} />
                </Link>
              </Grid>
            ))
        )}
      </Grid>
    </Box>
  );
};
